export default "__VITE_ASSET__Byvd11oh__"